import { useEffect, useState } from "react";
const useAuthState = () => {
    // Default the auth state to an empty object
    // but check if RiotBar has already loaded and updated the auth state before we are able to establish a listener
    const [authState, setAuthState] = useState(() => (typeof window !== "undefined" && window?.RiotBar?.account?.getAuthState()) || {
        name: "",
        tag: "",
        region: "",
        isAuthenticated: false,
        sub: "",
    });
    useEffect(() => {
        const checkAuthState = () => {
            if (typeof window === "undefined") {
                return;
            }
            const riotbarAuthState = window.RiotBar?.account.getAuthState();
            if (riotbarAuthState) {
                setAuthState(riotbarAuthState);
            }
        };
        document.addEventListener("riotbar_authcheckcomplete", checkAuthState);
        return () => {
            document.removeEventListener("riotbar_authcheckcomplete", checkAuthState);
        };
    }, []);
    return authState;
};
export default useAuthState;
